import React from 'react';
import ScrollTrigger from 'react-scroll-trigger';

import RichEditorContent from 'components/RichEditorContent';

import AbstractCmsElement from 'components/cms/elements/AbstractCmsElement';

export default class CmsElementTimelineBlock extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.state = {
      shown: false,
    };
  }

  shown = () => {
    this.setState({ shown: true });
  };

  render() {
    return (
      <ScrollTrigger onEnter={this.shown} className="timeline-block">
        <div className="timeline-point complete text-center bounce-in">
          <i className={this.getParamValue('icon', 'far fa-circle')} />
        </div>

        <div className={'timeline-content ' + (this.state.shown ? 'bounce-in ' : 'is-hidden ')}>
          <div className="card share full-width">
            <div className="card-block">
              <RichEditorContent content={'<p className="no-margin">' + this.getParamValue('content', '') + '</p>'} />
            </div>
            <div className="event-date">
              <small className="fs-12 hint-text">
                <span>{this.getParamValue('title', '')}</span>
              </small>
            </div>
          </div>
        </div>
      </ScrollTrigger>
    );
  }
}
CmsElementTimelineBlock.defaultProps = {
  index: '0',
};
